import { MousePointer2 } from "lucide-react";
import {
  pickEditChipLabel,
  type PickEditChatDisplay,
} from "@/lib/brand-site-preview-nav";
import { cn } from "@/lib/utils";

/** 点选改页在聊天里只展示指令条 + 商户原话；全文仍发给模型。 */
export function PickEditCommandCard({
  parsed,
  raw,
  align = "end",
  compact = false,
  showRawToggle = true,
}: {
  parsed: PickEditChatDisplay;
  raw: string;
  align?: "start" | "end";
  compact?: boolean;
  showRawToggle?: boolean;
}) {
  return (
    <div
      className={cn(
        "flex min-w-0 flex-col gap-1.5",
        align === "end" ? "items-end text-right" : "items-start text-left",
      )}
    >
      <span
        className="inline-flex max-w-full items-center gap-1 rounded-md border border-border/70 bg-background/80 px-2 py-0.5 text-[11px] font-medium text-muted-foreground"
        title={pickEditChipLabel(parsed)}
      >
        <MousePointer2 className="size-3 shrink-0" aria-hidden />
        <span className="truncate">{pickEditChipLabel(parsed)}</span>
      </span>
      <p
        className={cn(
          "whitespace-pre-wrap break-words",
          compact ? "text-xs leading-snug" : "leading-relaxed",
        )}
      >
        {parsed.userRequest}
      </p>
      {showRawToggle ? (
        <details className="w-full min-w-0 text-left">
          <summary className="cursor-pointer select-none text-[11px] text-muted-foreground/80 hover:text-muted-foreground">
            详情
          </summary>
          <pre className="mt-1 max-h-40 overflow-auto whitespace-pre-wrap break-words rounded-md bg-background/60 p-2 text-[10px] leading-snug text-muted-foreground">
            {raw}
          </pre>
        </details>
      ) : null}
    </div>
  );
}
